import slug from "../slug";

const getPrefix = (index = 1) => {
  const depth = {
    1: 'category',
    2: 'objet',
    3: 'reason',
    4: 'sub_reason',
    5: 'reason_need',
    6: 'sub_reason_need',
    7: 'sub_reason_need'
  }

  return depth[index]
}

const getCategoryKey = (categoryLevel, categorySlug) => {
  const prefix = getPrefix(categoryLevel)
  return `${prefix}_${categorySlug}`
}

const buildCategory = (categoryLevel, categorySlug, categoryTitle,
  categoryParentKey = null, categoryParentSlug = null, categoryParentTitle = null, categoryParentLevel = null,
  rootParentKey = null, rootParentSlug = null, rootParentTitle = null, rootParentLevel = null, category = null
) => {
  const key = getCategoryKey(categoryLevel, categorySlug)

  return [{
    key: key,
    slug: categorySlug,
    title: categoryTitle,
    level: categoryLevel,
    fr: categoryTitle,
    en: categoryTitle,
    parentKey: categoryParentKey,
    parentSlug: categoryParentSlug,
    parentTitle: categoryParentTitle,
    parentLevel: categoryParentLevel,
    rootParentKey: rootParentKey,
    rootParentSlug: rootParentSlug,
    rootParentTitle: rootParentTitle,
    rootParentLevel: rootParentLevel,
    id: category?.id,
    cat_parents_ids: category?.all_parent_id,
    all_parent_id: category?.all_parent_id,
    sla: category?.sla,
    priority: category?.priority
  }]
}

const walkInCategories = (categories, categoriesKeysToCheck = [], categoryLevel = 1, 
  categoryParentKey = null, categoryParentSlug = null, categoryParentTitle = null, categoryParentLevel = null,
  rootParentKey = null, rootParentSlug = null, rootParentTitle = null, rootParentLevel = null
  ) => {
  const result = []

  for (const category of categories) {
    const categoryTitle = category.title
    const categorySlug = slug(categoryTitle)
    let categoryKey = getCategoryKey(categoryLevel, categorySlug)

    let isChildCategory = category.hasOwnProperty('children') && category.children.length !== 0
    
    if(category.parent_id === null) {
      rootParentTitle = categoryTitle
      rootParentSlug = categorySlug
      rootParentKey = categoryKey
      rootParentLevel = categoryLevel
    }

    let categoryKeyTocheck = `${categoryKey}_${rootParentKey}`

    if (!categoriesKeysToCheck.includes(categoryKeyTocheck)) {
      result.push(...buildCategory(
        categoryLevel, categorySlug, categoryTitle, categoryParentKey, 
        categoryParentSlug, categoryParentTitle, categoryParentLevel,
        rootParentKey, rootParentSlug, rootParentTitle, rootParentLevel, category
      ))
      categoriesKeysToCheck.push(categoryKeyTocheck)
    }

    if(isChildCategory) {
      result.push(...walkInCategories(category.children, categoriesKeysToCheck, categoryLevel + 1, 
        categoryKey, categorySlug, categoryTitle, categoryLevel, 
        rootParentKey, rootParentSlug, rootParentTitle, rootParentLevel))
    }
  }
  
  return result
}

const groupCategoriesByParent = (categories)=> {
  const categoryMap = {};
  const rootCategories = [];

  categories.forEach(category => {
    category.children = [];
    categoryMap[category.id] = category;
  });

  categories.forEach(category => {
    if (category.parent_id === "" || category.parent_id === null) {
      category.parent_id = null;
    }

    if (category.parent_id === null) {
      rootCategories.push(category);
    } else {
      const parent = categoryMap[category.parent_id];
      if (parent) {
        parent.children.push(category);
      }
    }
  });

  return rootCategories;
}

const createcategoriesPerFlow = (categories) =>  {
  console.log('createcategoriesPerFlow called !!!!!!!!!!!!!!!!!!!!')
  const categoriesKeysToCheck = []
  let rootCategories = groupCategoriesByParent(categories)
  return walkInCategories(rootCategories, categoriesKeysToCheck)
}

export default createcategoriesPerFlow